// extracted by mini-css-extract-plugin
module.exports = {"hero":"styles_hero__ffjnJ","bg_image":"styles_bg_image__uT8W_","subtitle":"styles_subtitle__6Trlg","title":"styles_title__oWbyf","text":"styles_text__o_eiy"};